var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ww"},[_c('div',{staticClass:"dbt"},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('Func')],1)]),_c('transition',{attrs:{"name":"slide-left"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }